import { Box, Typography } from "@mui/material";
import React from "react";
import PurchaseOrders from "./PurchaseOrders";

const PurchaseOrdersPage = () => {
  return (
    <Box>
      <Typography variant="h4" sx={{ textAlign: "center" }}>
        Purchase Orders
      </Typography>
      <PurchaseOrders />
    </Box>
  );
};

export default PurchaseOrdersPage;
